import { render, staticRenderFns } from "./DialogShareMessage.vue?vue&type=template&id=1edf0d4f"
import script from "./DialogShareMessage.vue?vue&type=script&lang=js"
export * from "./DialogShareMessage.vue?vue&type=script&lang=js"
import style0 from "./DialogShareMessage.vue?vue&type=style&index=0&id=1edf0d4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports